/**
 * Shared TTS-surface copy — /text-to-speech page shell (maintenance,
 * connection retries, SEO) plus the small support components that
 * flank the studio: AlertModal, InsufficientCreditsAlert,
 * RateLimitDisplay, LanguageAlert, PWAInstallTip.
 * The studio UI itself (TTSLayoutEnhanced, TTSLeftPanelSteps) is a
 * separate follow-up.
 * Re-export shim over /locales/{en,ht,fr,es}.json (tts_shared key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.tts_shared,
  ht: ht.tts_shared,
  fr: fr.tts_shared,
  es: es.tts_shared,
  'pt-BR': ptBR.tts_shared,
  'zh-Hans': zhHans.tts_shared,
}

export default COPY
